export default __webpack_public_path__ + "static/media/down-4.744c396f.svg";